import Swal from "sweetalert2";
import PageNavigation from "../../PageNavigation";
import helpers from "../../../helpers";
import moment from "moment";

export const DeleteFile = async (api, item, urlPostParams, props) => {
  const restClient = props.core ? props.core.make("oxzion/restClient") : props.osjsCore.make("oxzion/restClient");
  let response = await restClient.request("v1", "/" + api, urlPostParams ? urlPostParams : {}, item.typeOfRequest ? item.typeOfRequest : "post");
  return response;
};

const updateActionHandler = (details, rowData, props, loader) => {
  rowData = { ...props.parentData, ...rowData };
  const alertAdapter = props.core?.make("oxzion/alert");
  loader.show();
  return new Promise((resolve) => {
    var queryRoute = helpers.ParameterHandler.replaceParams(props.appId, details?.params?.url ? details.params.url : details.route, rowData);
    var postData = {};
    try {
      if (details.params.postData) {
        Object.keys(details.params.postData).map((i) => {
          postData[i] = helpers.ParameterHandler.replaceParams(props.appId, details.params.postData[i], rowData);
        });
      } else {
        Object.keys(details.params).map((i) => {
          postData[i] = helpers.ParameterHandler.replaceParams(props.appId, details.params[i], rowData);
        });
        postData = rowData;
      }
    } catch (error) {
      postData = rowData;
    }
    helpers.ParameterHandler.updateCall(
      props.core,
      props.appId,
      queryRoute,
      postData,
      details?.params?.disableAppId ? details?.params?.disableAppId : true,
      details.method ? details.method : details.typeOfRequest,
    )
      .then((response) => {
        if (details?.params?.downloadFile && response.status == 200) {
          helpers.ParameterHandler.downloadFile(response).then((result) => {
            loader.destroy();
            var downloadStatus = result ? "success" : "failed";
            resolve({ status: downloadStatus });
          });
        } else {
          loader.destroy();
          resolve(response);
        }
      })
      .catch(() => {
        alertAdapter?.show({
          title: "Unexpected Error",
          confirmButtonText: "Got it",
          icon: "error",
        });
        loader.destroy();
      });
  });
};

const responseHandler = (response, item, loader, props) => {
  loader.destroy();
  
  // Handle custom popup configuration
  if (response?.data?.popupConfig) {
    Swal.fire(response.data.popupConfig);
    refreshHandler(props.appId);
    return;
  }

  const alertAdapter = props?.core?.make("oxzion/alert");
  const isSuccess = response?.status === "success";
  
  // Prepare alert configuration
  const alertConfig = {
    title: isSuccess
      ? item?.successMessage || item?.params?.successNotification || response?.message || response?.data?.message
      : item?.errorMessage || response.errors?.[0]?.message || response.message,
    confirmButtonText: "Got it",
    icon: isSuccess ? "success" : "error",
  };

  alertAdapter?.show(alertConfig);
  
  if (isSuccess) {
    refreshHandler(props.appId);
  }
};

const refreshHandler = (appId) => {
  let ev = new CustomEvent("handleGridRefresh", {
    detail: { hideLoader: true },
    bubbles: true,
  });
  if (document.getElementById(`navigation_${appId}`)) {
    document.getElementById(`navigation_${appId}`).dispatchEvent(ev);
  }
};

export const buttonAction = async (actionCopy, rowData = {}, props) => {
  const loader = props.core.make("oxzion/splash");
  const alertAdapter = props.core ? props?.core.make("oxzion/alert") : props.osjsCore.make("oxzion/alert");
  const restClient = props.core ? props.core.make("oxzion/restClient") : props.osjsCore.make("oxzion/restClient");
  const isFetchingRef = props.isFetchingRef;
  var action = actionCopy;
  if (action?.predefinedCallback) {
    action.predefinedCallback?.();
    return;
  }
  if (action.content) {
    action.details = action.content;
  }
  //renaming the file_uuid to uuid cause that is how the data should be passed
  if (rowData["file_uuid"]) {
    rowData["uuid"] = rowData["file_uuid"];
    delete rowData["file_uuid"];
  }
  var mergeRowData = props.currentRow ? { ...props.currentRow, ...rowData } : rowData;
  if (action.page_id) {
    PageNavigation.loadPage(props.appId, props.pageId, action.page_id, null, null, null, null, null, null, action.popupConfig, rowData);
  } else if (action.details) {
    var copyPageContent = [];
    if (rowData.rygRule) {
      copyPageContent.push({
        type: "HTMLViewer",
        content: rowData.rygRule,
        className: "rygBadge",
      });
    }
    var checkForTypeUpdate = false;
    var pageId = null;
    if (action.details.length > 0) {
      action.details.every(async (item, index) => {
        if (item.type == "Update") {
          var PageRenderDiv = document.getElementById(props.parentDiv);
          loader.show(PageRenderDiv ? PageRenderDiv : null, item.loaderMessage);
          checkForTypeUpdate = true;
          isFetchingRef.current = true;
          if (item.method == "DELETE") {
            alertAdapter
              ?.show({
                title: "Are you sure?",
                text: "Do you really want to delete the record? This cannot be undone.",
                confirmButtonText: "Yes, delete",
                cancelButtonText: "No, cancel",
                icon: "question",
              })
              .then(async (result) => {
                if (result) {
                  const response = await updateActionHandler(item, mergeRowData, props, loader);
                  responseHandler(response, item, loader, props);
                  isFetchingRef.current = false; // Mark as not pending
                } else {
                  isFetchingRef.current = false;
                }
              });
          } else {
            const response = await updateActionHandler(item, mergeRowData, props, loader);
            responseHandler(response, item, loader, props);
            isFetchingRef.current = false;
          }
        } else if (item.type == "API") {
          isFetchingRef.current = true;
          if (item.typeOfRequest == "delete") {
            action.updateOnly = true;
            loader.show();
            var url = helpers.ParameterHandler.replaceParams(props.appId, item.route, mergeRowData);
            DeleteFile(url, item, null, props).then((response) => {
              responseHandler?.(response, item, loader, props);
              if (props.dataLoaderComponent === "WidgetGridLoader" && response.status === "success") {
                setTimeout(() => {
                  document.getElementById(`navigation_${props.appId}`)?.dispatchEvent(new CustomEvent("handleOIRefresh"));
                }, 500);
              }
              isFetchingRef.current = false;
            });
          } else if (item.typeOfRequest == "post") {
            action.updateOnly = true;
            var url = helpers.ParameterHandler.replaceParams(props.appId, item.route, mergeRowData);
            var params = helpers.ParameterHandler.replaceParams(props.appId, item.params, mergeRowData);
            var postData = { ...mergeRowData, ...params };
            loader.show();
            restClient
              .request("v1", "/" + url, postData, "post", {
                "Content-Type": "application/json",
              })
              .then((response1) => {
                loader.destroy();
                if (response1.status == "success") {
                  if (item.successNotification) {
                    props.notif.current.notify(item.successNotification, "", "OK", false);
                  }
                  responseHandler?.(response1, item, loader, props);
                } else {
                  props.notif.current.notify(response1.message, "", "OK", false);
                }
                isFetchingRef.current = false;
              })
              .catch((err) => {
                props.notif.current.notify("Error", err.message || "Could not process request", "danger");
                console.error(err);
                isFetchingRef.current = false;
              });
          } else {
            const response = await updateActionHandler(item, mergeRowData, props, loader);
            responseHandler(response, item, loader, props);
            isFetchingRef.current = false;
          }
        } else if (item.type == "APIRequest") {
          isFetchingRef.current = true;
          action.updateOnly = true;
          var urlPostParams = {};
          if (item.params && item.params.urlPostParams) {
            urlPostParams = helpers.ParameterHandler.replaceParams(props.appId, item.params.urlPostParams, mergeRowData);
          }
          var url = helpers.ParameterHandler.replaceParams(props.appId, item.route, mergeRowData);
          alertAdapter
            ?.show({
              title: "Are you sure?",
              text: "Do you really want to delete the record? This cannot be undone.",
              confirmButtonText: "Yes, delete",
              cancelButtonText: "No, cancel",
              icon: "question",
            })
            .then((result) => {
              if (result) {
                loader.show();
                DeleteFile(url, item, urlPostParams, props).then((response) => {
                  loader.destroy();
                  refreshHandler?.(response);
                  if (response.status == "success") {
                    props.notif.current.notify("Success", "Deleted Successfully", "success");
                  } else {
                    props.notif.current.notify("Error", response.message, "danger");
                  }
                  isFetchingRef.current = false;
                });
              } else {
                isFetchingRef.current = false;
              }
            });
        } else {
          if (item.params && item.params.page_id) {
            pageId = item.params.page_id;
            if (item.params.params && typeof item.params.params === "string") {
              var newParams = helpers.ParameterHandler.replaceParams(props.appId, item.params.params, mergeRowData);
              mergeRowData = { ...newParams, ...mergeRowData };
            } else if (item.params.params && typeof item.params.params === "object") {
              var params = {};
              Object.keys(item.params.params).map((i) => {
                params[i] = helpers.ParameterHandler.replaceParams(props.appId, item.params.params[i], mergeRowData);
              });
              mergeRowData = { ...params, ...mergeRowData };
            }
            copyPageContent = [];
          } else if (item.type == "Event") {
            let ev = new CustomEvent(item.eventName, {
              detail: mergeRowData,
              bubbles: true,
            });
            document.getElementsByClassName(`Window_${props.appName}`)[0].dispatchEvent(ev);
          } else {
            var pageContentObj = {};
            mergeRowData = { ...props.parentData, ...mergeRowData };
            pageContentObj = helpers.ParameterHandler.replaceParams(props.appId, item, mergeRowData);
            copyPageContent.push(pageContentObj);
          }
        }
      });
      action.updateOnly
        ? null
        : PageNavigation.loadPage(
            props.appId,
            props.pageId,
            pageId,
            action.icon,
            true,
            action.name,
            mergeRowData,
            copyPageContent,
            undefined,
            action.popupConfig,
            mergeRowData,
          );
    }
  }
};
